// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SeatListRowHeader__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AirlineSeatSelection/SeatListRowHeader.scss
 ** module id = 881
 ** module chunks = 1
 **/